import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import type { TConstantPaths } from '@hooks';

import { HeroContainer } from './styles';

const backgrounds = {
  couple: (
    <StaticImage
      src="../../images/hero-banner-desktop.png"
      alt="background"
      className="hero__image"
    />
  ),
  streak: (
    <StaticImage
      src="../../images/services.png"
      alt="background"
      className="hero__image"
    />
  ),
  highway: (
    <StaticImage
      src="../../images/about-us.png"
      alt="background"
      className="hero__image"
    />
  ),
};

interface IHero
  extends React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>> {
  subtitle: string;
  title: string;
  link?: {
    to: TConstantPaths;
    innerText: string;
  };
  slim?: boolean;
  background?: keyof typeof backgrounds;
}

const Hero = ({
  subtitle,
  title,
  link,
  children,
  className,
  slim = true,
  background = 'couple',
  ...rest
}: IHero) => {
  const hasLink =
    Object.prototype.toString.call(link) === '[object Object]' &&
    Object.prototype.hasOwnProperty.call(link, 'to');

  return (
    <HeroContainer
      className={[
        'hero',
        slim ? 'hero--slim' : null,
        `hero--${background}`,
        className,
      ].join(' ')}
      {...rest}
    >
      <div className="hero__background">
        {!slim && (
          <>
            <div className="hero__gradient"></div>
            {backgrounds[background]}
          </>
        )}
        {slim && backgrounds[background]}
      </div>
      {!slim && <div className="hero__spacer"></div>}
      <div className="hero__content">
        <span>
          <h2 className="hero__h2">{subtitle}</h2>
          <h1 className="hero__h1">{title}</h1>
        </span>
        {hasLink && (
          <Link className="hero__link" to={link!.to}>
            {link!.innerText}
          </Link>
        )}
        {children}
      </div>
    </HeroContainer>
  );
};

export { Hero };
